import $ from 'jquery';
window.$ = window.jQuery = $;

import 'bootstrap';

// Import language recognition library
import * as cld3 from 'cld3-asm';

// Import specific jQuery UI widgets
import 'jquery-ui/ui/core'; // Adds essential utilities required by other jQuery UI components
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui-timepicker-addon';
import 'jquery-ui/ui/widgets/draggable';

// Import CSS files - THIS SHOULD STAY IN APP.CSS
//import '../css/jquery-ui.css'; // Use your Redmond theme CSS

import 'jquery-mask-plugin/dist/jquery.mask';
import 'blueimp-file-upload/js/jquery.iframe-transport';
import 'blueimp-file-upload/js/jquery.fileupload';
import 'datatables.net';
import 'datatables.net-bs4';
import 'datatables.net-responsive';
import 'datatables.net-responsive-bs4';

// Function to normalize the locale
function normalizeLocale(locale) {
    // Ensure the locale follows the correct case pattern
    locale = locale.toLowerCase();
    const parts = locale.split('-');
    return {
        full: parts[0] + (parts[1] ? '-' + parts[1].toUpperCase() : ''),
        base: parts[0]
    };
}

// Initialize and set the locale for DatePicker and DateTimePicker
window.setDatePickerRegion = async function () {
    const { full: locale, base: baseLocale } = normalizeLocale(glb_locale);

    // For English (en-US), jQuery UI uses the built-in defaults.
    if (locale === 'en-US') {
        // console.info("Locale is en-US; using built-in defaults.");
    } else {
        try {
            await import(`jquery-ui/ui/i18n/datepicker-${locale}`);
            await import(`jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-${locale}`);
        } catch (error) {
            // console.warn(`Failed to load full locale ${locale}. Trying base language...`);
            // Fallback to the base language if the regional variant fails
            try {
                await import(`jquery-ui/ui/i18n/datepicker-${baseLocale}`);
                await import(`jquery-ui-timepicker-addon/dist/i18n/jquery-ui-timepicker-${baseLocale}`);
            } catch (error) {
                console.log(error);
                console.warn(`Locale ${baseLocale} not found, using default.`);
            }
        }
    }

    // Set the locale for DatePicker
    const region = $.datepicker.regional[locale] || $.datepicker.regional[baseLocale] || $.datepicker.regional[''];
    $.datepicker.setDefaults(region);

    // Set the locale for DateTimePicker
    if ($.timepicker && $.timepicker.regional) {
        const timeRegion = $.timepicker.regional[locale] || $.timepicker.regional[baseLocale] || $.timepicker.regional[''];
        $.timepicker.setDefaults(timeRegion);
    }
};
